import Api from "../../apis/api";
import globalapi from "../../apis/apifactory";
export default {

  getcurrentproject() {
    return globalapi.getselectedproject();
  },
  addParameterBySteps(varstep, varparms) {
    let varproject = this.getcurrentproject();
    let apiurl =
      "save_project_details/?project=" +
      varproject +
      "&step=" +
      varstep +
      "&" +
      varparms;
      //alert(apiurl);
    return Api.get(apiurl);
  },

  gettheParameterByProjectStepSummary() {
    return globalapi.gettheParameterByProjectStep("2");
  },



  get_sdataheaders() {
    let apiurl = "sdata-headers/?project=" + this.getcurrentproject() + "&step=2";
    return Api.get(apiurl);
  },
 
  get_qqPlotdata(chartFilter, varparam) {
 
    let apiurl = "qqplot/?" + varparam + "&step=4&var=" + chartFilter;
 
    return Api.get(apiurl);
  },
  get_BoxPlotdata(varparam) {
    let apiurl = "expl/?" + varparam + "&step=4&&start1=01-01-2020&end1=01-02-2020&start2=01-03-2020&end2=02-04-2020&start3=01-05-2020&end3=01-06-2020";
 
    return Api.get(apiurl);
  },
  get_tabledata(vardt1_1, vardt1_2, vardt2_1, vardt2_2, vardt3_1, vardt3_2, varparam) {
 
    let apiurl = "expl/?project=" + this.getcurrentproject() + "&step=4&" + varparam + "&start1=" + vardt1_1 + "&end1=" + vardt1_2 + "&start2=" + vardt2_1 + "&end2=" + vardt2_2 + "&start3=" + vardt3_1 + "&end3=" + vardt3_2 + "";
    return Api.get(apiurl);
  },
  get_Bardata() {
 
    let apiurl = "sdata/?project=" + this.getcurrentproject() + "&step=2";
 
    return Api.get(apiurl);
  },
  //http://mmmplatformapi-env.eba-dtpwwm2u.ap-south-1.elasticbeanstalk.com/seasonality-plots/?project=15&step=5&country=india&brand=xyz&level=national&time=date&sales_value=sales&sales_volume=volume&activity=non_clm_call,clm_call,webinar,mass_email,email_1to1,phone_call&competitor=comp1&zscore=2&bzscore=0&subzscore=0&trend=1&season=1&comp=1
  get_lineplotdata() {
    let apiurl = "sdata/?project=" + this.getcurrentproject() + "&step=2";
    return Api.get(apiurl);
  },
  
  get_heatmap() {
  
    let apiurl = "corr/?project=" + this.getcurrentproject() + "&step=4";
    return Api.get(apiurl);
  },

  // new Api
  api_get_project_variable_list() {

    let apiurl = "get_project_variable_list/?project=" + this.getcurrentproject();
  
    return Api.get(apiurl);
  },
  api_get_project_region_list() {

    let apiurl = "get_project_region_list/?project=" + this.getcurrentproject();
  
    return Api.get(apiurl);
  },
  api_get_step2_output(start1, end1, start2, end2, start3, end3, region) {

    let apiurl = "get_step2_output/?project=" + this.getcurrentproject() + "&step=2&start1=" + start1 + "&end1=" + end1 + "&start2=" + start2 + "&end2=" + end2 + "&start3=" + start3 + "&end3=" + end3 + "&region=" + region + "";
    //alert('api_get_step2_output' + apiurl);
    return Api.get(apiurl);
  },
  call_save_find_decay() {
    let apiurl = "save_find_decay/?project=" + this.getcurrentproject() + "";
  ////alert(apiurl);
    return Api.get(apiurl);
  },
  call_find_decay() {
    let apiurl = "find_decay/?step=3&project=" + this.getcurrentproject() + "";
    ////alert(apiurl);
    return Api.get(apiurl);
  },
  call_save_channel_decay() {
    let apiurl = "save_channel_decay/?step=3&project=" + this.getcurrentproject() + "";
    ////alert(apiurl);
    return Api.get(apiurl);
  },
  callsave_channel_decay_forsave(varregion, varparamarray) {
    let apiurl = "save_channel_decay/?project=" + this.getcurrentproject() + "&region=" + varregion + "&param=" + varparamarray + "";
    return Api.get(apiurl);
  },
  
  // label constants
  ExploreData_Headeing: "Explore Data",
  ExploreData_helpheading: "Explore Data",
  ExploreData_description: "Explore Data No Desc"
}